// src/plugins/loading.js
import Vue from "vue";
import GlobalLoading from "@/components/GlobalLoading/index.vue";

const LoadingConstructor = Vue.extend(GlobalLoading);
const loadingInstance = new LoadingConstructor();

loadingInstance.$mount();
document.body.appendChild(loadingInstance.$el);

Vue.prototype.$load = {
  show() {
    loadingInstance.visible = true;
  },
  hide() {
    loadingInstance.visible = false;
  },
};